import { STR_ERRORS } from "../Strings";
import { NON_CALLABLE_HOOKS, CALLABLE_HOOKS } from "../Hooks";
import { applySportsbookQueries } from "../Helpers";
// set is a reserved word in the language
export function setter(connectionName, t, p, v // Proxy auto-passed params
) {
    if (p === NON_CALLABLE_HOOKS.query) {
        if (!t[CALLABLE_HOOKS.isValidQuery](v)) {
            throw new Error(STR_ERRORS.WrongTypeForQuerySet);
        }
        t[p] = v;
        applySportsbookQueries(connectionName, t);
        return true;
    }
    return Reflect.set(t, p, v);
}
//# sourceMappingURL=setter.js.map